/** True if buffer looks like a PDF (starts with %PDF-). */
export function isPdfArrayBuffer(data: ArrayBuffer): boolean {
  if (data.byteLength < 5) return false;
  const u8 = new Uint8Array(data, 0, 5);
  return (
    u8[0] === 0x25 &&
    u8[1] === 0x50 &&
    u8[2] === 0x44 &&
    u8[3] === 0x46 &&
    u8[4] === 0x2d
  );
}

/** User-facing message when bytes are not a valid PDF or the response was an error page. */
export function describeNonPdfResponse(
  status: number,
  contentType: string | null,
  previewUtf8: string,
): string {
  if (status === 401 || status === 403) {
    return 'Could not load the document (session expired or access denied). Try refreshing the page.';
  }
  if (status === 404) {
    return 'The file was not found. It may have been removed or expired.';
  }
  const ct = (contentType ?? '').toLowerCase();
  if (ct.includes('text/html') || /<html[\s>]/i.test(previewUtf8)) {
    return 'The server returned a web page instead of a PDF. Check that you are signed in and try again.';
  }
  if (ct.includes('json') || previewUtf8.trim().startsWith('{')) {
    return 'The server returned an error instead of a PDF. Try again or contact support if this persists.';
  }
  return 'This file is not a valid PDF or the download was incomplete.';
}
